@use "ui/styles/colors";

.wrapper {
  position: relative;

  :global {
    .category {
      padding-right: 8px;

      div:last-child {
        margin-left: auto;
      }
    }

    .category_none,
    .category_prospect {
      &:hover {
        color: colors.$gray70;
        background-color: colors.$gray10;
      }

      &.selected {
        color: colors.$gray70;
      }
    }

    .category_contract {
      &:hover {
        color: colors.$blue;
        background-color: colors.$blueLightest;
      }

      &.selected {
        color: colors.$blue;
      }
    }

    .category_testing {
      &:hover {
        color: colors.$greenDark;
        background-color: colors.$greenLightest;
      }

      &.selected {
        color: colors.$greenDark;
      }
    }

    .category_closed {
      &:hover {
        color: colors.$gray95;
        background-color: colors.$gray20;
      }

      &.selected {
        color: colors.$gray95;
      }
    }
  }
}

.centerLink {
  display: flex;
  align-items: center;
}
